import React, { useEffect, useRef, useState } from 'react'; // Make sure to import React
import { Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import * as Device from 'expo-device';
import testAPI from '../api/testing';

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: false,
    shouldSetBadge: false,
  }),
});

/**
 * Adds the push notification device token to the UCD Database.
 *
 * @param string token the device token found by Expo
 *
 * @return empty return
 */
export const AddTokenToDB = async ({ token, userId }) => {
  const requestParams = {
    deviceToken: token,
    userId: userId,
    deviceModel: Device.modelName,
    deviceOSName: Device.osName,
    deviceOSVersion: Device.osVersion,
  };

  try {
    /*
    // only add if the token does not already exist in the MongoDB
    const existsResponse = await mongodb.post(
      '/pushnotifications/device-tokens/findbydevicetoken',
      { token: token }
    );
    if (
      existsResponse.status === 200 &&
      undefined === existsResponse.data.error
    ) {
      // token exists, return out of the function
      ////console.log('The Device token Already Exists');
      return true;
    }
    // add the new token to the MongoDB
    const response = await mongodb.post(
      '/pushnotifications/device-tokens/create',
      requestParams
    );
    */
    /** TESTING */
    const formData = new FormData();
    for (let key in requestParams) {
      formData.append(key, requestParams[key]);
    }
    ////console.log('Push Notification Data to Post', formData);
    const response = await testAPI.post(
      '/push-notification-testing.php',
      formData
    );
    ////console.log('Save Device Token Response', response.data);
    if (response.status !== 200) {
      alert('There was a problem saving the push notification token.');
      /*
      Bugsnag.notify(
        'Error receiving the push notification token. Response: ' + response
      );
      */
      return false;
    }
  } catch (e) {
    if (e.response) {
      if (e.response.status >= 400) {
        /*
        Bugsnag.notify(
          'Error adding device token to DB. Response: ' +
            e.response.status +
            ': ' +
            e.response.data
        );
        */
        console.log(
          'Error adding device token to DB. Response: ' +
            e.response.status +
            ': ' +
            e.response.data
        );
        return false;
      }
    } else if (e.request) {
      /*
      Bugsnag.notify(
        'Add Device Token to DB, No Response. Error: ' + e.request
      );
      */
      //console.log('Add Device Token to DB, No Response. Error: ' + e.request);
      return false;
    } else {
      //Bugsnag.notify('Device Token Error: ' + e.message);
      //console.log('Device Token Error: ' + e.message);
      return false;
    }
  }
  return true;
};

const registerForPushNotificationsAsync = async () => {
  //Bugsnag.leaveBreadcrumb('Registering for Push Notifications');
  let token;
  if (Device.isDevice) {
    const { status: existingStatus } =
      await Notifications.getPermissionsAsync();
    let finalStatus = existingStatus;
    //console.log('Current Push Notification Permission Status', finalStatus);
    if (existingStatus !== 'granted') {
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
    }
    token = await Notifications.getDevicePushTokenAsync();
    //console.log('This Device Token', token.data);
  } else {
    alert('Must use a physical device for push notifications');
    return false;
  }
  if (Platform.OS === 'android') {
    Notifications.setNotificationChannelAsync('default', {
      name: 'default',
      importance: Notifications.AndroidImportance.MAX,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: '#FF231F7C',
    });
  }
  console.log('Push Notification Token Data', token.data);
  return token.data;
};

function PushNotificationHandler({ userId }) {
  const [notification, setNotification] = useState(false);
  const notificationListener = useRef();
  const responseListener = useRef();

  useEffect(() => {
    registerForPushNotificationsAsync().then((token) =>
      AddTokenToDB({ token: token, userId: userId })
    );

    notificationListener.current =
      Notifications.addNotificationReceivedListener((notification) => {
        setNotification(notification);
      });
    responseListener.current =
      Notifications.addNotificationResponseReceivedListener((response) =>
        console.log(response)
      );
  }, []);

  return null;
}

export default PushNotificationHandler;
